const FILTERS_WITH_UNIT = [
    'landArea',
    'factoryArea',
    'mezzanineArea',
    'officeShowroomArea',
    'otherArea',
    'shopArea',
    'showroomArea',
    'warehouseArea',
    'workshopArea',
    'buildingArea',
    'equivalentBuildingArea',
];

/**
 * Compares two filter objects for equality, with special handling for filters with units.
 * For filters with units (e.g., landArea, buildingArea), the unit property is only compared
 * if the min or max values are non-empty.
 *
 * @param {Object} filters1 - First filter object to compare
 * @param {Object} filters2 - Second filter object to compare
 * @returns {boolean} - True if filters are equal (considering the unit comparison rules), false otherwise
 */
const compareFilters = (filters1, filters2) => {
    if (!filters1 || !filters2) return false;

    const keys1 = Object.keys(filters1);
    const keys2 = Object.keys(filters2);

    if (keys1.length !== keys2.length) return false;

    for (const key of keys1) {
        const val1 = filters1[key];
        const val2 = filters2[key];

        // For filters with unit
        if (FILTERS_WITH_UNIT.includes(key)) {
            // Compare min and max
            if (val1?.min !== val2?.min || val1?.max !== val2?.max) {
                return false;
            }
            // Only compare unit if min or max has a value (not empty)
            if ((val1?.min !== '' || val1?.max !== '') && val1?.unit !== val2?.unit) {
                return false;
            }
        } else {
            // For other filters, use JSON.stringify for deep comparison
            if (JSON.stringify(val1) !== JSON.stringify(val2)) {
                return false;
            }
        }
    }

    return true;
};

export { FILTERS_WITH_UNIT, compareFilters };
